import { getStatistQueue } from './statist-queue';
// Слушатели сообщений для всех инстансев и форков StatistClient
export var addMessageListener = function (messageListener) {
    var statistQueue = getStatistQueue();
    if (!statistQueue.listeners) {
        statistQueue.listeners = [];
    }
    statistQueue.listeners.push(messageListener);
};
export var getMessageListeners = function () {
    var statistQueue = getStatistQueue();
    if (!statistQueue.listeners) {
        statistQueue.listeners = [];
    }
    return statistQueue.listeners;
};
//# sourceMappingURL=message-listener.js.map